// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Success_cardWrapper__KjOSH","innerCardWrapper":"Success_innerCardWrapper__Oe+VE","cardBody":"Success_cardBody__Kb6JZ"};